import { render, staticRenderFns } from "./AvatarSettings.vue?vue&type=template&id=14bf88c6&scoped=true"
import script from "./AvatarSettings.vue?vue&type=script&lang=ts"
export * from "./AvatarSettings.vue?vue&type=script&lang=ts"
import style0 from "./AvatarSettings.vue?vue&type=style&index=0&id=14bf88c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bf88c6",
  null
  
)

export default component.exports